export const holdScale = 1.05;
